<div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title mt-2">
        Import groups to <i><strong>{{modalData.pool?.name ?? 'New Pool'}}</strong></i>
    </h5>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('')"
    >
        <span aria-hidden="true">Close</span>
    </button>
</div>

<div class="modal-body container" ngbAutofocus>
    <app-dc-file-upload
            [allowMultipleFiles]="false"
            [autoLoad]="false"
            [acceptedFiles]="'.csv'"
            (filesChanged)="processDone.set(false)"
            maxFileSize="6000000000"
    >
    </app-dc-file-upload>
</div>

<div class="modal-footer">
    <button
            class="btn btn-outline-primary"
            (click)="importFiles()"
            [disabled]="
      !fileUploader?.files.length ||
       fileUploader.errors.length ||
       fileUploader.uploadInProgress ||
       (processDone() && !fileUploader.uploadInProgress)"
    >
        Import File
    </button>
</div>
